import i18next from 'i18next';

export const formatList = (
  items: ReadonlyArray<string | number>,
  options?: Intl.ListFormatOptions,
): string => {
  const locale = i18next.language.startsWith('pt') ? 'pt-BR' : 'en';
  return new Intl.ListFormat(locale, {
    type: 'conjunction',
    ...options,
  }).format(items.map(String));
};
